import React from "react";
import Modal from "react-modal";

const ConfirmDeleteAccountModal = (props) => (
    <Modal
        isOpen = { props.visible }
        contentLabel = "Account to delete"
        onRequestClose = { props.hideModal }
        closeTimeoutMS = { 200 }
        className = "modal"    
    >
        <div className="modal_header">
            <div className="modal_icon">
                <i class="fa fa-exclamation-circle fa-shake fa-2xl modal_icon_warning" aria-hidden="true"></i>
            </div>
            <h2 className="modal__title">Are you sure you'd like to delete your TrackIt account?</h2>
            <p className="modal_text">Note: This action will <span className="callout_text">not</span> affect your AuthFX account.</p>
        </div>

        <div>
            <button className="button confirm_yes" onClick = { props.deleteAccount }>Yes</button> 
            <span> </span>
            <button className="button button--secondary confirm_no" onClick= { props.hideModal }>Nevermind</button>
        </div>  
    
    </Modal>
)

export default ConfirmDeleteAccountModal;


// WEBPACK FOOTER //
// ./src/components/ConfirmDeleteAccountModal.js